var _circle, _circle2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoodBeenBetter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "url(#paint0_radial_40_49873)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 16,
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2727 17.5627C17.2727 19.5809 15.6364 21.2173 13.6182 21.2173C11.6 21.2173 9.96362 19.5809 9.96362 17.5627C9.96362 15.5446 11.6 13.9082 13.6182 13.9082C15.6364 13.9082 17.2727 15.5446 17.2727 17.5627Z",
    fill: "#1A99DC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 17.1272C18 19.1454 16.3636 20.7817 14.3455 20.7817C12.3273 20.7817 10.6909 19.1454 10.6909 17.1272C10.6909 15.109 12.3273 13.4727 14.3455 13.4727C16.3636 13.4727 18 15.109 18 17.1272Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0181 17.1278C16.0181 18.0551 15.2726 18.8005 14.3635 18.8005C13.4544 18.8005 12.709 18.0551 12.709 17.1278C12.709 16.2005 13.4544 15.4551 14.3635 15.4551C15.2726 15.4733 16.0181 16.2187 16.0181 17.1278Z",
    fill: "#14110E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7272 16.3808C13.7272 16.799 13.3818 17.1445 12.9636 17.1445C12.5454 17.1445 12.2 16.799 12.2 16.3808C12.2 15.9626 12.5454 15.6172 12.9636 15.6172C13.4 15.6172 13.7272 15.9445 13.7272 16.3808Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4182 17.5629C29.4182 19.5811 27.7819 21.2174 25.7637 21.2174C23.7455 21.2174 22.1091 19.5811 22.1091 17.5629C22.1091 15.5447 23.7455 13.9084 25.7637 13.9084C27.8 13.8902 29.4182 15.5447 29.4182 17.5629Z",
    fill: "#1A99DC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.509 20.7817C28.5274 20.7817 30.1636 19.1456 30.1636 17.1272C30.1636 15.1089 28.5274 13.4727 26.509 13.4727C24.4907 13.4727 22.8545 15.1089 22.8545 17.1272C22.8545 19.1456 24.4907 20.7817 26.509 20.7817Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2727 17.1277C28.2727 18.0731 27.509 18.8549 26.5636 18.8549C25.6181 18.8549 24.8545 18.0913 24.8545 17.1277C24.8545 16.1822 25.6181 15.4004 26.5636 15.4004C27.509 15.4186 28.2727 16.1822 28.2727 17.1277Z",
    fill: "#14110E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9272 16.3463C25.9272 16.7826 25.5817 17.1281 25.1453 17.1281C24.709 17.1281 24.3635 16.7826 24.3635 16.3463C24.3635 15.9099 24.709 15.5645 25.1453 15.5645C25.5817 15.5645 25.9272 15.9099 25.9272 16.3463Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8363 16.0545C17.3818 14.5636 15.9818 13.4727 14.3454 13.4727C12.709 13.4727 11.3272 14.5636 10.8545 16.0545H17.8363Z",
    fill: "#60C2F5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9999 16.0545C29.5453 14.5636 28.1453 13.4727 26.509 13.4727C24.8726 13.4727 23.4908 14.5636 23.0181 16.0545H29.9999Z",
    fill: "#60C2F5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M14.8364 25.0871C14.8364 27.3053 13.0364 29.1235 10.8182 29.1235C8.60005 29.1235 6.80005 27.3235 6.80005 25.0871C6.80005 22.869 8.60005 21.0508 10.8182 21.0508C13.0364 21.0508 14.8364 22.8508 14.8364 25.0871Z",
    fill: "url(#paint1_radial_40_49873)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M33.3818 25.0871C33.3818 27.3053 31.5818 29.1235 29.3636 29.1235C27.1455 29.1235 25.3455 27.3235 25.3455 25.0871C25.3455 22.869 27.1455 21.0508 29.3636 21.0508C31.5818 21.0508 33.3818 22.8508 33.3818 25.0871Z",
    fill: "url(#paint2_radial_40_49873)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5999 10.9451C12.7272 11.4905 11.8181 11.9996 10.9817 12.6178C10.6544 12.8542 10.9635 13.3996 11.2908 13.1633C12.1272 12.5451 13.0181 12.036 13.909 11.4905C14.2544 11.2724 13.9453 10.7269 13.5999 10.9451Z",
    fill: "#1A99DC"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5999 10.4724C12.7272 11.0179 11.8181 11.527 10.9817 12.1452C10.6544 12.3815 10.9635 12.927 11.2908 12.6906C12.1272 12.0724 13.0181 11.5633 13.909 11.0179C14.2544 10.7997 13.9453 10.2542 13.5999 10.4724Z",
    fill: "#14110E"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6727 10.9451C27.5455 11.4905 28.4545 11.9996 29.2909 12.6178C29.6182 12.8542 29.3091 13.3996 28.9818 13.1633C28.1454 12.5451 27.2545 12.036 26.3636 11.4905C26.0182 11.2724 26.3273 10.7269 26.6727 10.9451Z",
    fill: "#1A99DC"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6727 10.4724C27.5455 11.0179 28.4545 11.527 29.2909 12.1452C29.6182 12.3815 29.3091 12.927 28.9818 12.6906C28.1454 12.0724 27.2545 11.5633 26.3636 11.0179C26.0182 10.7997 26.3273 10.2542 26.6727 10.4724Z",
    fill: "#14110E"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1999 25.9466C22.7272 29.5466 16.6181 29.3284 13.5999 25.2557C13.4181 25.0193 13.0727 25.3466 13.2545 25.583C16.4181 29.8557 22.8727 30.0557 26.509 26.2921C26.7272 26.0739 26.4181 25.7284 26.1999 25.9466Z",
    fill: "#14110E"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_40_49873",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20 20) rotate(90) scale(20)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.487641,
    stopColor: "#A8D8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4FB3E8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_40_49873",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.8214 25.0786) scale(4.0178 4.03226)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A99DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1788,
    stopColor: "#1A99DC",
    stopOpacity: 0.8196
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4174,
    stopColor: "#1A99DC",
    stopOpacity: 0.733333
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6896,
    stopColor: "#1A99DC",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9848,
    stopColor: "#1A99DC",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_40_49873",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.3668 25.0786) scale(4.0178 4.03226)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A99DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1788,
    stopColor: "#1A99DC",
    stopOpacity: 0.8196
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4174,
    stopColor: "#1A99DC",
    stopOpacity: 0.733333
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6896,
    stopColor: "#1A99DC",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9848,
    stopColor: "#1A99DC",
    stopOpacity: 0.01
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoodBeenBetter);
export default __webpack_public_path__ + "static/media/Mood_Been-Better.fc1cbb633e56581e81a8d39671988b00.svg";
export { ForwardRef as ReactComponent };